var _g, _rect, _g2, _rect2, _g3, _rect3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_70_2",
    "data-name": "Component 70 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 46.652 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.652,
    height: 39,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.652,
    height: 38,
    rx: 4.5,
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 15.093,
    height: 20.53,
    rx: 0.928,
    transform: "translate(18.57 13.592)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-2424.447 -605.436)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x2: 3.469,
    transform: "translate(2445.423 622.741)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x2: 2.818,
    transform: "translate(2453.886 622.741)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x2: 2.166,
    transform: "translate(2445.423 623.858)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    x2: 2.166,
    transform: "translate(2448.013 623.858)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x2: 1.274,
    transform: "translate(2445.423 625.574)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x2: 5.267,
    transform: "translate(2447.143 625.574)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x2: 3.886,
    transform: "translate(2452.77 625.574)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    x1: 1.776,
    transform: "translate(2454.879 627.257)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x1: 4.062,
    transform: "translate(2450.334 627.257)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x1: 4.522,
    transform: "translate(2445.423 627.257)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x1: 1.274,
    transform: "translate(2455.382 630.898)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x1: 5.267,
    transform: "translate(2449.668 630.898)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x1: 3.886,
    transform: "translate(2445.423 630.898)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 1.776,
    transform: "translate(2445.423 629.215)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x2: 4.062,
    transform: "translate(2447.682 629.215)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x2: 4.522,
    transform: "translate(2452.134 629.215)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x2: 1.798,
    transform: "translate(2451.398 632.581)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 3.185,
    transform: "translate(2453.47 632.581)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x2: 2.047,
    transform: "translate(2445.423 632.581)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x2: 2.279,
    transform: "translate(2448.169 632.581)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x1: 1.274,
    transform: "translate(2455.382 635.947)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x1: 5.267,
    transform: "translate(2449.668 635.947)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    x1: 3.886,
    transform: "translate(2445.423 635.947)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    x2: 1.776,
    transform: "translate(2445.423 634.264)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    x2: 4.062,
    transform: "translate(2447.682 634.264)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    x2: 4.522,
    transform: "translate(2452.134 634.264)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    x2: 1.798,
    transform: "translate(2451.398 637.63)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    x2: 3.185,
    transform: "translate(2453.47 637.63)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    x2: 2.047,
    transform: "translate(2445.423 637.629)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x2: 2.279,
    transform: "translate(2448.169 637.629)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 15.093,
    height: 20.53,
    rx: 0.928,
    transform: "translate(15.57 10.928)",
    fill: "#fff",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(-2424.447 -605.436)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 3.469,
    transform: "translate(2442.423 620.076)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x2: 2.818,
    transform: "translate(2450.886 620.076)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    x2: 2.166,
    transform: "translate(2442.423 621.193)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x2: 2.166,
    transform: "translate(2445.013 621.193)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x2: 1.274,
    transform: "translate(2442.423 622.908)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x2: 5.267,
    transform: "translate(2444.143 622.908)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x2: 3.886,
    transform: "translate(2449.77 622.908)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x1: 1.776,
    transform: "translate(2451.879 624.591)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x1: 4.062,
    transform: "translate(2447.334 624.591)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x1: 4.522,
    transform: "translate(2442.423 624.591)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x1: 1.274,
    transform: "translate(2452.382 628.232)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 5.267,
    transform: "translate(2446.668 628.232)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x1: 3.886,
    transform: "translate(2442.423 628.232)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x2: 1.776,
    transform: "translate(2442.423 626.549)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x2: 4.062,
    transform: "translate(2444.682 626.549)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    x2: 4.522,
    transform: "translate(2449.134 626.549)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    x2: 1.798,
    transform: "translate(2448.398 629.915)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313",
    "data-name": "Line 313",
    x2: 3.185,
    transform: "translate(2450.47 629.915)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314",
    "data-name": "Line 314",
    x2: 2.047,
    transform: "translate(2442.423 629.915)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    x2: 2.279,
    transform: "translate(2445.169 629.915)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x1: 1.274,
    transform: "translate(2452.382 633.281)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x1: 5.267,
    transform: "translate(2446.668 633.281)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x1: 3.886,
    transform: "translate(2442.423 633.281)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    x2: 1.776,
    transform: "translate(2442.423 631.598)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    x2: 4.062,
    transform: "translate(2444.682 631.598)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x2: 4.522,
    transform: "translate(2449.134 631.598)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x2: 1.798,
    transform: "translate(2448.398 634.964)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 3.185,
    transform: "translate(2450.47 634.964)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x2: 2.047,
    transform: "translate(2442.423 634.964)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    x2: 2.279,
    transform: "translate(2445.169 634.964)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 15.093,
    height: 20.53,
    rx: 0.928,
    transform: "translate(12.986 8)",
    fill: "#707070"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(-2424.447 -605.436)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x2: 3.469,
    transform: "translate(2439.524 616.363)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x2: 2.818,
    transform: "translate(2447.987 616.363)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x2: 2.166,
    transform: "translate(2439.524 617.48)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x2: 2.166,
    transform: "translate(2442.114 617.48)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x2: 1.274,
    transform: "translate(2439.524 619.196)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    x2: 5.267,
    transform: "translate(2441.243 619.196)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x2: 3.886,
    transform: "translate(2446.871 619.196)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x1: 1.776,
    transform: "translate(2448.98 620.879)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x1: 4.062,
    transform: "translate(2444.435 620.879)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x1: 4.522,
    transform: "translate(2439.524 620.879)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x1: 1.274,
    transform: "translate(2449.483 624.52)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x1: 5.267,
    transform: "translate(2443.769 624.52)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x1: 3.886,
    transform: "translate(2439.523 624.52)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    x2: 1.776,
    transform: "translate(2439.523 622.837)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_340",
    "data-name": "Line 340",
    x2: 4.062,
    transform: "translate(2441.783 622.837)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x2: 4.522,
    transform: "translate(2446.235 622.837)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x2: 1.798,
    transform: "translate(2445.499 626.203)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x2: 3.185,
    transform: "translate(2447.571 626.203)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x2: 2.047,
    transform: "translate(2439.523 626.203)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x2: 2.279,
    transform: "translate(2442.27 626.203)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x1: 1.274,
    transform: "translate(2449.483 629.569)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x1: 5.267,
    transform: "translate(2443.769 629.569)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x1: 3.886,
    transform: "translate(2439.523 629.569)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x2: 1.776,
    transform: "translate(2439.523 627.886)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x2: 4.062,
    transform: "translate(2441.783 627.886)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x2: 4.522,
    transform: "translate(2446.235 627.886)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x2: 1.798,
    transform: "translate(2445.499 631.251)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x2: 3.185,
    transform: "translate(2447.571 631.251)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 2.047,
    transform: "translate(2439.523 631.251)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 2.279,
    transform: "translate(2442.27 631.251)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadIcon);
export default __webpack_public_path__ + "static/media/ReadIcon.219434d60f6967615a71dc361fcb173a.svg";
export { ForwardRef as ReactComponent };